export const TEMPLATE_TYPES = [
  'first-email',
  'followup-email',
  'first-sms',
  'followup-sms',
];
